import { SxProps, Theme } from '@mui/material/styles';

export const dividerSx: SxProps<Theme> = {};
